import { configurationService } from '@/data/services/configuration/configuration-service'
import { Configuration } from '@/data/services/configuration/configuration-service-types'
import { Company } from '@/domain/models/company/company-model'
import { CompanyDetail } from '@/domain/usecases/company/company-detail'
import { queryClient } from '@/infra/http'
import { QueryClient } from '@tanstack/react-query'

export type CompanyDetailLoadDataType = {
  company: Company.Model
  configurations: Configuration.Model[]
}

export async function loadCompanyDetail(id: string): Promise<CompanyDetailLoadDataType> {
  const module = await import('@/main/factories/usecases')
  const makeRemoteDetail = module.makeRemoteCompanyDetail as (
    queryClient: QueryClient
  ) => CompanyDetail
  const remoteCompanyDetail = makeRemoteDetail(queryClient)

  const [company, configurations] = await Promise.all([
    remoteCompanyDetail.get(id),
    configurationService.getAllFromCompany(id)
  ])

  return { company, configurations }
}
